module.exports = __webpack_public_path__ + "static/team-b880204f9a4f64afcb3245099b865b23.jpg";